// ═══════════════════════════════════════════════════════════════════════════════
// Inventory submission photos via authed API → blob URL (no GCS URL in img src)
// ═══════════════════════════════════════════════════════════════════════════════

import { useAuthedApiImageBlobUrl } from '../receipt/useReceiptImageDisplay';

const EXPIRED_IMAGE_FALLBACK_SRC = '/img/img_expired-1.webp';

const buildInventoryPhotoApiPath = (
  props: TaskInstanceInventoryPhotoImgProps
): string => {
  const base = `/api/task-instances/${encodeURIComponent(props.taskInstanceId)}`;
  if (props.variant === 'v2Location') {
    return `${base}/inventory/v2/locations/${props.locationIndex}/photos/${props.photoIndex}`;
  }
  return `${base}/inventory/stocktake-photos/${props.photoIndex}`;
};

export type TaskInstanceInventoryPhotoImgProps = {
  taskInstanceId: string;
  alt: string;
  className?: string;
} & (
  | { variant: 'v2Location'; locationIndex: number; photoIndex: number }
  | { variant: 'stocktake'; photoIndex: number }
);

export const TaskInstanceInventoryPhotoImg = (props: TaskInstanceInventoryPhotoImgProps) => {
  const { alt, className = '' } = props;
  const apiPath = buildInventoryPhotoApiPath(props);
  const { objectUrl, loading, error } = useAuthedApiImageBlobUrl(apiPath);

  if (loading) {
    return (
      <div
        className={`flex items-center justify-center bg-gray-100 dark:bg-gray-800 ${className}`}
        role="status"
        aria-live="polite"
      >
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary-200 border-t-primary-600" />
      </div>
    );
  }

  if (error || !objectUrl) {
    return <img src={EXPIRED_IMAGE_FALLBACK_SRC} alt={alt} className={className} />;
  }

  return <img src={objectUrl} alt={alt} className={className} />;
};
